import * as React from "react";

import { cn } from "./utils";

const Label = React.forwardRef(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn(
      "text-sm font-semibold text-foreground",
      className
    )}
    {...props}
  />
));
Label.displayName = "Label";

export { Label };

